<template>
	<!-- Плавающая кнопка быстрой связи (FAB) -->
	<transition name="fab-fade">
		<div v-if="isVisible" class="fab-container">
			<!-- Главная кнопка -->
			<button
				class="fab-main"
				:class="{ 'fab-open': isMenuOpen }"
				@click="toggleMenu"
				aria-label="Быстрая связь"
			>
				<transition name="icon-rotate" mode="out-in">
					<svg
						v-if="!isMenuOpen"
						key="phone"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 00-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"
							fill="currentColor"
						/>
					</svg>
					<svg
						v-else
						key="close"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
							fill="currentColor"
						/>
					</svg>
				</transition>
			</button>

			<!-- Меню опций -->
			<transition name="menu-slide">
				<div v-if="isMenuOpen" class="fab-menu">
					<a href="tel:+74951362515" class="fab-menu-item" @click="closeMenu">
						<div class="fab-menu-icon">
							<svg
								width="20"
								height="20"
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 00-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"
									fill="currentColor"
								/>
							</svg>
						</div>
						<span class="fab-menu-text">+7 (495) 136-25-15</span>
					</a>

					<a
						href="mailto:project@metall-trade.ru"
						class="fab-menu-item"
						@click="closeMenu"
					>
						<div class="fab-menu-icon">
							<svg
								width="20"
								height="20"
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
									fill="currentColor"
								/>
							</svg>
						</div>
						<span class="fab-menu-text">Email</span>
					</a>

					<router-link to="/auth" class="fab-menu-item" @click="closeMenu">
						<div class="fab-menu-icon">
							<svg
								width="20"
								height="20"
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
									fill="currentColor"
								/>
							</svg>
						</div>
						<span class="fab-menu-text">Регистрация</span>
					</router-link>
				</div>
			</transition>
		</div>
	</transition>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'

export default {
	name: 'FloatingActionButton',
	setup() {
		const isVisible = ref(false)
		const isMenuOpen = ref(false)

		// Показываем FAB после прокрутки 300px
		const handleScroll = () => {
			isVisible.value = window.scrollY > 300
			// Закрываем меню при скролле
			if (isMenuOpen.value) {
				isMenuOpen.value = false
			}
		}

		const toggleMenu = () => {
			isMenuOpen.value = !isMenuOpen.value
		}

		const closeMenu = () => {
			isMenuOpen.value = false
		}

		onMounted(() => {
			window.addEventListener('scroll', handleScroll, { passive: true })
		})

		onUnmounted(() => {
			window.removeEventListener('scroll', handleScroll)
		})

		return {
			isVisible,
			isMenuOpen,
			toggleMenu,
			closeMenu,
		}
	},
}
</script>

<style scoped>
/* Контейнер FAB */
.fab-container {
	position: fixed;
	bottom: 30px;
	left: 30px;
	z-index: 9999;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 12px;
}

/* Главная кнопка */
.fab-main {
	width: 60px;
	height: 60px;
	border-radius: 50%;
	background: linear-gradient(135deg, #0095ec 0%, #0077c2 100%);
	border: none;
	box-shadow: 0 4px 20px rgba(0, 149, 236, 0.4);
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	color: white;
	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	position: relative;
	overflow: hidden;
}

.fab-main::before {
	content: '';
	position: absolute;
	top: 50%;
	left: 50%;
	width: 0;
	height: 0;
	border-radius: 50%;
	background: rgba(255, 255, 255, 0.3);
	transform: translate(-50%, -50%);
	transition: width 0.6s, height 0.6s;
}

.fab-main:hover::before {
	width: 100%;
	height: 100%;
}

.fab-main:hover {
	transform: scale(1.1);
	box-shadow: 0 6px 30px rgba(0, 149, 236, 0.6);
}

.fab-main:active {
	transform: scale(0.95);
}

.fab-main.fab-open {
	background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);
	box-shadow: 0 4px 20px rgba(255, 107, 107, 0.4);
}

/* Анимация иконки */
.icon-rotate-enter-active,
.icon-rotate-leave-active {
	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.icon-rotate-enter-from {
	transform: rotate(-180deg) scale(0);
	opacity: 0;
}

.icon-rotate-leave-to {
	transform: rotate(180deg) scale(0);
	opacity: 0;
}

/* Меню опций */
.fab-menu {
	display: flex;
	flex-direction: column;
	gap: 8px;
	margin-bottom: 8px;
}

.fab-menu-item {
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 12px 20px;
	background: white;
	border-radius: 30px;
	box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
	text-decoration: none;
	color: #2d2d2d;
	font-family: var(--font-family-poppins, 'Poppins', sans-serif);
	font-size: 14px;
	font-weight: 500;
	transition: all 0.3s ease;
	white-space: nowrap;
}

.fab-menu-item:hover {
	background: #0095ec;
	color: white;
	transform: translateX(5px);
	box-shadow: 0 4px 16px rgba(0, 149, 236, 0.3);
}

.fab-menu-icon {
	width: 24px;
	height: 24px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
}

.fab-menu-text {
	line-height: 1;
}

/* Анимации появления */
.fab-fade-enter-active,
.fab-fade-leave-active {
	transition: all 0.3s ease;
}

.fab-fade-enter-from,
.fab-fade-leave-to {
	opacity: 0;
	transform: translateY(20px) scale(0.8);
}

.menu-slide-enter-active {
	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.menu-slide-leave-active {
	transition: all 0.2s cubic-bezier(0.4, 0, 1, 1);
}

.menu-slide-enter-from {
	opacity: 0;
	transform: translateY(10px);
}

.menu-slide-leave-to {
	opacity: 0;
	transform: translateY(10px) scale(0.9);
}

/* Адаптивность */
@media (max-width: 768px) {
	.fab-container {
		bottom: 20px;
		left: 20px;
	}

	.fab-main {
		width: 56px;
		height: 56px;
	}

	.fab-menu-item {
		padding: 10px 16px;
		font-size: 13px;
	}
}
</style>
